import {ITimeoutService, IOnInit} from "angular";
import {VolatilityChange} from "../../models/VolatilityChange";
import {UserConfig} from "../../../../types/UserConfig";
import {VolatilityMoversService} from "../../service/VolatilityMoversService";

export const CompactVolMovers = "compactVolMovers";

export function compactVolMovers() {
    return {
        templateUrl: "app/components/watchlist/content/vol/CompactVolMovers.html",
        bindings: {
        },
        controllerAs: "ctrl",
        controller: CompactVolMoversComponentController
    };
}

export class CompactVolMoversComponentController implements IOnInit {
    public gainers: Array<VolatilityChange> = [];
    public losers: Array<VolatilityChange> = [];

    /** @ngInject */
    public constructor(private $timeout: ITimeoutService,
                       private userConfig: UserConfig,
                       private volatilityMoversService: VolatilityMoversService) {
    }

    public $onInit(): void {
        this.volatilityMoversService.asObservable()
            .subscribe(m => {
                this.$timeout(() => {
                    this.gainers = m.gainers;
                    this.losers = m.losers;
                }, 0);
            });
        this.volatilityMoversService.refresh();
    }
}
